import { render, staticRenderFns } from "./policyNew.vue?vue&type=template&id=d9c9b692"
import script from "./policyNew.vue?vue&type=script&lang=js"
export * from "./policyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports